import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';

import { Modal } from 'react-bootstrap'

import { POST, httpOk } from 'helpers/api'

const initData = {
    "name": '',
    "weight_grams": ""
};

function CreateVariants({ modal, setModal, getData, id }) {
    const { t } = useTranslation();

    const [sendData, setSendData] = useState({ ...initData });

    async function create() {
        var sendDataCopy = { ...sendData }
        const response = await POST(`/recipes/${id}/variants/`, sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData });
            getData();
        }
    }

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('create_variant')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('specify_recipe_and_weight')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('name')}</label>
                        <input type="text" placeholder={t('name')} name="name"
                            value={sendData.name} onChange={(e) => handleChange(e)} />
                    </div>


                    <div className="form-group">
                        <label>{t('weight_grams')}</label>
                        <input type="text" placeholder={t('weight_grams')} name="weight_grams"
                            value={sendData.weight_grams} onChange={(e) => handleChange(e)} />
                    </div>

                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('save')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default CreateVariants